import React from 'react';

import './styles/generatedSOA.css';

const GeneratedSOA = ({ selectedAccount, selectedProperty, selectedUnits, startDate, endDate, transactions, contentRef }) => {

    const filteredTransactions = transactions.filter((txn) => {
        const txnDate = new Date(txn.createdAt);
        return txnDate >= new Date(startDate) && txnDate <= new Date(endDate);
    });

    const paymentsDuringPeriod = filteredTransactions
        .filter((txn) => txn.type.toLowerCase() === 'payment')
        .reduce((sum, txn) => sum + Math.abs(txn.amount), 0);

    const invoicesDuringPeriod = filteredTransactions
        .filter((txn) => txn.type.toLowerCase() === 'invoice')
        .reduce((sum, txn) => sum + (txn.amount || 0), 0);

    const unpaidAmountDue = transactions
        .filter((txn) =>
            txn.type.toLowerCase() === 'invoice' &&
            new Date(txn.dueDate) < new Date() // Past the deadline
        )
        .reduce((sum, txn) => sum + txn.openBalance, 0);


    const currentDate = new Date();
    const formattedDate = `${currentDate.toLocaleDateString()} ${currentDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;

    return (
        <div className="print-content" ref={contentRef}>
            <div className="soa-main-content">
                <h2 id="soa-header">Statement of Account</h2>
                <hr></hr>
                <div id="soa-info">
                    <div id="soa-owner">
                        <div className="soa-info">
                            <p className="soa-label">ACCOUNT</p>
                            <p className="soa-name">{selectedAccount}</p>
                        </div>
                        <div className="soa-info">
                            <p className="soa-label">PROPERTY</p>
                            <p className="soa-name">{selectedProperty}</p>
                        </div>
                        <div className="soa-info">
                            <p className="soa-label">UNIT</p>
                            <p className="soa-name">{selectedUnits}</p>
                        </div>
                    </div>
                    <table id="soa-info-table">
                        <colgroup>
                            <col style={{ width: "65%" }} />
                            <col style={{ width: "35%" }} />
                        </colgroup>
                        <tbody>
                            <tr>
                                <td className="soa-label">STATEMENT DATE</td>
                                <td style={{ textAlign: 'right' }}>{startDate.format("MM/DD/YY")}</td>
                            </tr>
                            <tr>
                                <td className="soa-label">STATEMENT PERIOD</td>
                                <td style={{ textAlign: 'right' }}>{endDate.format("MM/DD/YY")}</td>
                            </tr>
                            <tr>
                                <td colSpan={2} style={{ height: "10px" }}>&nbsp;</td>
                            </tr>
                            <tr>
                                <td className="soa-label">PAYMENTS DURING PERIOD</td>
                                <td style={{ textAlign: 'right' }}>PHP {formatMoney(paymentsDuringPeriod)}</td>
                            </tr>
                            <tr>
                                <td className="soa-label">INVOICES DURING PERIOD</td>
                                <td style={{ textAlign: 'right' }}>PHP {formatMoney(invoicesDuringPeriod)}</td>
                            </tr>
                            <tr className="soa-balance">
                                <td className="soa-label">UNPAID AMOUNT DUE</td>
                                <td style={{ textAlign: 'right' }}>PHP {formatMoney(unpaidAmountDue)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <table id="soa-table">
                    <colgroup>
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "30%" }} />
                        <col style={{ width: "20%" }} />
                        <col style={{ width: "20%" }} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>DATE</th>
                            <th>TYPE</th>
                            <th>REFERENCE NO.</th>
                            <th>AMOUNT</th>
                            <th>UNPAID AMOUNT</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredTransactions.length === 0 ? (
                            <tr>
                                <td colSpan="5" style={{ textAlign: 'center' }}>No transactions found from the given time period</td>
                            </tr>
                        ) : (
                            filteredTransactions.map((txn) => (
                                <React.Fragment key={txn.id}>
                                    <tr>
                                        <td>{txn.createdAt}</td>
                                        <td>{txn.type}</td>
                                        <td>{txn.reference}</td>
                                        <td>{formatMoney(txn.amount)}</td>
                                        <td>{txn.type.toLowerCase() === 'invoice' ? formatMoney(txn.openBalance) : '-'}</td>
                                    </tr>
                                </React.Fragment>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            <footer>
                <hr></hr>
                <div id="soa-footer">
                    <img src="/alt-logo/yellow-plain.png" alt="gocondo-logo" />
                    <p>Date Issued: {formattedDate}</p>
                </div>
            </footer>
        </div>
    )
}

function formatMoney(amount) {
    return amount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

export default GeneratedSOA;